import { render, staticRenderFns } from "./FeatureUpdateScreen.vue?vue&type=template&id=afb3151e&"
import script from "./FeatureUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./FeatureUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports